module.exports = __webpack_public_path__ + "img/business-as-usual.64421561.svg";